import React from 'react'

import {
  OpportunityOccurrencePersonGroup,
  OpportunityResponseWithRecurrenceInfo,
  OpportunityStatus,
} from 'Event/interfaces/interfaceCreateEditEvent'
import { getVisibilityLabel, OpportunityVisibility as OpportunityVisibilityType } from 'Event/interfaces'
import { ExpandableCell } from 'core/table/cells/modern'
import { EventStableLink } from './EventStableLink'

export const EventVisibility = ({
  event,
  visibilityGroups,
}: {
  event: OpportunityResponseWithRecurrenceInfo
  visibilityGroups?: OpportunityOccurrencePersonGroup[]
}) => {
  let label = getVisibilityLabel(event.visibility)
  if (event.visibility === OpportunityVisibilityType.SELECT_GROUPS_ONLY) {
    label += ':'
  }

  return (
    <>
      {label}
      {visibilityGroups && (
        <>
          <br />
          <ExpandableCell
            value={visibilityGroups
              .map(({ group: { name, closed }, approvedMembersOnly }) => {
                if (!closed) return name
                return `${name} - ${approvedMembersOnly ? 'Approved Members' : 'Applicants'}`
              })
              .join(', ')}
            noPadding
          />
        </>
      )}
      {event.schedulable && event.status !== OpportunityStatus.Concluded && <EventStableLink event={event} />}
    </>
  )
}
